"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartsTooltipZoomSliderValue = ChartsTooltipZoomSliderValue;
var React = _interopRequireWildcard(require("react"));
var _NoSsr = _interopRequireDefault(require("@mui/material/NoSsr"));
var _Popper = _interopRequireDefault(require("@mui/material/Popper"));
var _ChartsTooltip = require("@mui/x-charts/ChartsTooltip");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * The root component of the zoom slider tooltip.
 * @ignore - internal component.
 */const ChartsZoomSliderTooltipRoot = (0, _styles.styled)(_Popper.default, {
  name: 'MuiChartsZoomSliderTooltip',
  slot: 'Root'
})(({
  theme
}) => ({
  pointerEvents: 'none',
  zIndex: theme.zIndex.modal
}));
const MODIFIERS = [{
  name: 'offset',
  options: {
    offset: [0, 4]
  }
}];
function ChartsTooltipZoomSliderValue({
  anchorEl,
  open,
  placement,
  modifiers = MODIFIERS,
  children
}) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoSsr.default, {
    children: open ? /*#__PURE__*/(0, _jsxRuntime.jsx)(ChartsZoomSliderTooltipRoot, {
      open: open,
      anchorEl: anchorEl,
      placement: placement,
      modifiers: modifiers,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChartsTooltip.ChartsTooltipPaper, {
        sx: {
          paddingX: 0.5
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          variant: "caption",
          children: children
        })
      })
    }) : null
  });
}